/**
 * Filled play triangle used wherever a Spotify preview can be started.
 * Replaces the Spotify wordmark glyph; colour comes from `currentColor`.
 */
export function PlayIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}
